/* 4U fit guide.
   Adds a quiet "how does it fit" scale to the top of the Description tab on every product page:
   Runs small / True to size / Runs large. Scale only, no advice line underneath.

   HOW A PRODUCT'S FIT IS DECIDED, in order:
   1. A product tag set in the Shopify admin: fit-runs-small, fit-runs-large, fit-true-to-size,
      or fit-hide to show no fit guide on that product.
   2. The RUNS list below (by product handle).
   3. Otherwise: true to size.
   Products in SKIP never show a fit guide. */
(function(){
  if (window.__fuFitGuide) return;
  window.__fuFitGuide = true;

  var script = document.currentScript;
  var handle = (script && script.getAttribute('data-handle')) || '';
  var tagFit = (script && script.getAttribute('data-fit')) || '';

  var RUNS = {
    'conquer-mens-activewear-shorts': 'small'   /* Conquer 4" Shorts */
  };
  var SKIP = ['gift-cards-4u', '4u-lifting-straps'];

  var COPY = {
    small: { label: 'Runs small' },
    'true': { label: 'True to size' },
    large: { label: 'Runs large' }
  };
  var ORDER = ['small', 'true', 'large'];

  if (!handle || tagFit === 'hide' || SKIP.indexOf(handle) > -1) return;
  var fit = COPY[tagFit] ? tagFit : (RUNS[handle] || 'true');
  if (!COPY[fit]) fit = 'true';

  /* Subtle version: no panel, hairline track, small marker, light grey text.
     It should read as part of the description, not as a feature box. */
  var css = ''
    + '.fu-fit{margin:0 0 18px !important;padding:0 0 16px;border-bottom:1px solid rgba(23,23,23,.08);background:none;color:#171717;opacity:1;font-family:inherit;line-height:1.2;}'
    + '.fu-fit *{box-sizing:border-box;}'
    + '.fu-fit__head{display:flex;justify-content:space-between;align-items:baseline;gap:12px;margin:0 0 12px;}'
    + '.fu-fit__eyebrow{font-size:11px;font-weight:400;color:#8f8f8a;}'
    + '.fu-fit__verdict{font-size:12px;font-weight:500;color:#171717;}'
    + '.fu-fit__track{position:relative;height:1px;margin:0 4px;background:#dcdcd8;}'
    + '.fu-fit__stop{position:absolute;top:50%;width:3px;height:3px;margin:-1.5px 0 0 -1.5px;border-radius:50%;background:#c8c8c3;}'
    + '.fu-fit__stop.is-on{width:8px;height:8px;margin:-4px 0 0 -4px;background:#171717;box-shadow:0 0 0 3px #fff;}'
    + '.fu-fit__labels{display:grid;grid-template-columns:1fr 1fr 1fr;margin:9px 0 0;font-size:10.5px;font-weight:400;letter-spacing:0;text-transform:none;color:#b0b0ab;}'
    + '.fu-fit__labels span:nth-child(2){text-align:center;}'
    + '.fu-fit__labels span:nth-child(3){text-align:right;}'
    + '.fu-fit__labels span.is-on{color:#55554f;font-weight:500;}';

  function build(){
    var box = document.createElement('div');
    box.className = 'fu-fit';
    box.setAttribute('data-fu-fit', fit);

    var head = document.createElement('div');
    head.className = 'fu-fit__head';
    var eyebrow = document.createElement('span');
    eyebrow.className = 'fu-fit__eyebrow';
    eyebrow.textContent = 'Fit';
    var verdict = document.createElement('span');
    verdict.className = 'fu-fit__verdict';
    verdict.textContent = COPY[fit].label;
    head.appendChild(eyebrow);
    head.appendChild(verdict);

    var track = document.createElement('div');
    track.className = 'fu-fit__track';
    track.setAttribute('role', 'img');
    track.setAttribute('aria-label', 'Fit: ' + COPY[fit].label);
    var labels = document.createElement('div');
    labels.className = 'fu-fit__labels';
    labels.setAttribute('aria-hidden', 'true');
    ORDER.forEach(function(k, i){
      var stop = document.createElement('span');
      stop.className = 'fu-fit__stop' + (k === fit ? ' is-on' : '');
      stop.style.left = (i * 50) + '%';
      track.appendChild(stop);
      var l = document.createElement('span');
      l.textContent = COPY[k].label;
      if (k === fit) l.className = 'is-on';
      labels.appendChild(l);
    });

    box.appendChild(head);
    box.appendChild(track);
    box.appendChild(labels);
    return box;
  }

  /* The Description tab on the product page (falls back to the first tab) */
  function target(){
    var tabs = document.querySelectorAll('.product__accordion');
    var found = null, details = null, first = null;
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].closest('quick-view, .quick-view')) continue;
      if (!first) first = tabs[i];
      var s = tabs[i].querySelector('summary');
      var t = (s ? s.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t === 'description') { found = tabs[i]; break; }
      if (!details && t.indexOf('detail') > -1) details = tabs[i];
    }
    var tab = found || details || first;
    return tab ? tab.querySelector('.details__content') : null;
  }

  function mount(){
    var content = target();
    if (!content || content.querySelector('.fu-fit')) return;
    if (!document.getElementById('fu-fit-css')) {
      var st = document.createElement('style');
      st.id = 'fu-fit-css';
      st.textContent = css;
      document.head.appendChild(st);
    }
    content.insertBefore(build(), content.firstChild);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
